import { Box, Typography } from '@mui/material';
import MessageInput from './MessageInput';

export default function ChatHome({ onSend, variant = 'full' }) {
  const isEmbedded = variant === 'embedded';
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        sx={{
          fontSize: 32,
          fontWeight: 500,
          mb: 4,
          color: 'text.primary'
        }}
      >
        What can I help with?
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 880 }}>
        <MessageInput onSend={onSend} />
      </Box>
    </Box>

    // <Box sx={{ mb: 2 }}>
    //   <Typography variant="h4" fontWeight={700}>
    //     Ask Phoenix AI about this video
    //   </Typography>

    //   <Typography variant="body2" color="text.secondary">
    //     Answers are generated using this video’s transcript, AI summary, and content ideas.
    //   </Typography>
    //   <Box sx={{ width: '100%', maxWidth: 880 }}>
    //    <MessageInput onSend={onSend} />
    //    </Box>
    // </Box>
  );
}
